/**
 * 设备相关工具函数
 */
import storage from './storage'

/**
 * 获取浏览器信息
 */
const getBrowserInfo = () => {
  const ua = navigator.userAgent
  const isWeChat = /MicroMessenger/i.test(ua)
  const isIOS = /iPhone|iPad|iPod/i.test(ua)
  const isAndroid = /Android/i.test(ua)
  const isMobile = isIOS || isAndroid
  
  return {
    userAgent: ua,
    platform: navigator.platform || 'unknown',
    language: navigator.language || 'zh-CN',
    vendor: navigator.vendor || 'unknown',
    isWeChat,
    isIOS,
    isAndroid,
    isMobile,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    devicePixelRatio: window.devicePixelRatio || 1
  }
}

/**
 * 生成设备唯一标识
 */
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

/**
 * 获取或生成设备指纹
 * @returns {string} 设备指纹
 */
export const getDeviceFingerprint = () => {
  // 尝试从存储中获取已有的设备指纹
  let fingerprint = storage.get('device_fingerprint')
  
  if (!fingerprint) {
    // 如果没有，则生成新的设备指纹
    try {
      // 获取浏览器信息
      const browserInfo = getBrowserInfo()
      
      // 组合多个设备特征生成指纹
      const features = [
        'h5',                                    // 平台标识
        browserInfo.isIOS ? 'ios' : browserInfo.isAndroid ? 'android' : 'web',
        browserInfo.screenWidth,
        browserInfo.screenHeight,
        browserInfo.language.split('-')[0],
        generateUUID()                          // 唯一标识
      ]
      
      // 生成指纹
      fingerprint = `device_${features.join('_').replace(/\s+/g, '_')}`
      
    } catch (error) {
      console.error('生成设备指纹失败:', error)
      // 降级方案：使用简单的随机字符串
      fingerprint = `device_${Date.now()}_${generateUUID()}`
    }
    
    // 保存设备指纹
    storage.set('device_fingerprint', fingerprint)
  }
  
  return fingerprint
}

/**
 * 清除设备指纹（用于调试或重置）
 */
export const clearDeviceFingerprint = () => {
  storage.remove('device_fingerprint')
}

/**
 * 获取设备类型
 */
export const getDeviceType = () => {
  const info = getBrowserInfo()
  if (info.isIOS) return 'ios'
  if (info.isAndroid) return 'android'
  if (info.isMobile) return 'mobile'
  return 'desktop'
}

/**
 * 判断是否在微信内
 */
export const isInWeChat = () => {
  return /MicroMessenger/i.test(navigator.userAgent)
}

/**
 * 获取系统信息（兼容uni-app接口）
 */
export const getSystemInfo = () => {
  const info = getBrowserInfo()
  return {
    brand: info.vendor,
    model: info.platform,
    system: info.userAgent,
    platform: getDeviceType(),
    language: info.language,
    screenWidth: info.screenWidth,
    screenHeight: info.screenHeight,
    pixelRatio: info.devicePixelRatio,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight
  }
}